import React from "react";
import style from './NotFound.module.css';

const NotFound = () => {
  return (
    <div className={style.NotFound}>
      <h1>Sorry, page not found!</h1>
    </div>
  );
}

export default NotFound;
